import { render, staticRenderFns } from "./gif-picker.vue?vue&type=template&id=d670e240&scoped=true&"
import script from "./gif-picker.vue?vue&type=script&lang=js&"
export * from "./gif-picker.vue?vue&type=script&lang=js&"
import style0 from "./gif-picker.vue?vue&type=style&index=0&id=d670e240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670e240",
  null
  
)

export default component.exports